import _ from 'lodash';
import { parse } from 'qs';

export interface IGetFreeRegisterUrlParams {
    created_from?: string;
    channel_code?: string;
    channel_source?: string;
    media_type?: string;
    promotion_plan?: string;
    promotion_cell?: string;
    from_page?: string;
    from_button?: string;
    inviter_id?: string;
    activity_type?: string;
    invitation_code?: string;
}

function getHashParams(hash: string, key: string) {
    if (hash.startsWith('/')) {
        hash = hash.substring(1);
    }
    const queryIndex = hash.indexOf('?');
    if (queryIndex !== -1) {
        const query = hash.substring(queryIndex + 1);

        const urlParams = new URLSearchParams(query);
        return urlParams.get(key)
    }
    return undefined
}

/**
 * 获取url参数
 */
export function getVar(
    key: string,
    type: 'string' | 'boolean' = 'string'
): any {
    const hash = window.location.hash.substring(1);
    if (hash) {
        return getHashParams(hash, key);
    }
    const query = parse(window.location.search, { ignoreQueryPrefix: true });
    if (_.has(query, key)) {
        const value = _.get(query, key) as string;
        if (_.isNull(value) || _.isUndefined(value)) {
            return true;
        }
        if (type === 'boolean') {
            if (_.lowerCase(value) === 'false') {
                return false;
            } else {
                return true;
            }
        }
        return value;
    }
}

function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
}

function isNilOrEmpty(value: string) {
    return !value || _.isNil(value)
}

/**
 *
 * @returns IGetFreeRegisterUrlParams
 */
export function getFreeRegisterUrlParams(): IGetFreeRegisterUrlParams {
    const freeRegisterParams = {
        created_from: getVar('created_from'),
        channel_code: getVar('channel_code'),
        channel_source: getVar('channel_source'),
        promotion_plan: getVar('promotion_plan'),
        promotion_cell: getVar('promotion_cell'),
        from_page: getVar('from_page'),
        from_button: getVar('from_button'),
        inviter_id: getVar('inviter_id'),
        activity_type: getVar('activity_type'),
        invitation_code: getVar('invitation_code'),
        media_type: isMobileDevice() ? 'Mobile' : '',
    }
    return _.omitBy(freeRegisterParams, isNilOrEmpty);
}
